export default {
  UNKNOWN: 'UNKNOWN',
  EXPIRE: 'EXPIRE',
  GIVE_AWAY: 'GIVE_AWAY'
}
